// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3wSxc","content":"Consent_content__bYxRG","footer":"Consent_footer__20pI1"};